<template>
  <div class="mv-bg-main" style="height: 100%; background-color: #FFF;">
    <el-row>
      <el-col :span="24">
        <el-card shadow="always">
          <div slot="header" style="text-align: center;" class="clearfix">
            <span>供应商信息详情</span>
          </div>
          <el-tabs v-model="activeName" >
            <el-tab-pane label="基本信息" name="first">
              <el-form
              ref="infoEssential"
              :model="infoEssential"
              label-width="120px">
                <el-form-item label="业务系统" prop="sysId">
                  <el-select
                    disabled
                    v-model="infoEssential.sysId"
                    placeholder="请选择业务系统"
                    clearable
                    filterable
                    style="width:100%"
                  >
                    <el-option
                      v-for="(item, index) in sysData"
                      :key="index"
                      :label="item.systemName"
                      :value="item.systemId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="供应商全称" prop="supName">
                  <el-input
                    v-model="infoEssential.supName"
                    maxlength="40"
                    disabled
                    placeholder="请输入供应商全称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="供应商简称" prop="supShortName">
                  <el-input
                    v-model="infoEssential.supShortName"
                    maxlength="15"
                    disabled
                    placeholder="请输入供应商简称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="付款类型" prop="paymentType">
                  <el-select
                    disabled
                    v-model="infoEssential.paymentType"
                    placeholder="请选择付款类型"
                    clearable
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in paymentType"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="供应商状态" prop="state">
                  <el-radio-group disabled v-model="infoEssential.state">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="已报备的IP" prop="ipaddress">
                  <el-input
                    type="textarea"
                    disabled
                    v-model="infoEssential.ipaddress"
                    maxlength="200"
                    placeholder="请输入已报备的IP"
                  ></el-input>
                  <p>注：多个IP时请用";"隔开，末尾处无需添加符号</p>
                </el-form-item>
                <div style="textAlign: center;margin:20px 0">
                  <el-button @click="returnList">关闭</el-button>
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="联系人信息" name="second">
              <el-form
              ref="infoContacts"
              :model="infoContacts"
              label-width="120px">
              <el-form-item label="联系人姓名" prop="contacts">
                <el-input
                  v-model="infoContacts.contacts"
                  disabled
                  placeholder="请输入联系人姓名"
                  maxlength="16"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人号码" prop="conPhone">
                <el-input
                  v-model="infoContacts.conPhone"
                  disabled
                  placeholder="请输入联系人号码"
                  maxlength="11"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人邮箱" prop="conMail">
                <el-input
                  maxlength="30"
                  disabled
                  v-model="infoContacts.conMail"
                  placeholder="请输入联系人邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="sex">
                <el-radio-group disabled v-model="infoContacts.sex">
                  <el-radio label="1">男</el-radio>
                  <el-radio label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="职务" prop="post">
                <el-input
                  maxlength="60"
                  disabled
                  v-model="infoContacts.post"
                  placeholder="请输入职务"
                ></el-input>
              </el-form-item>
              <el-form-item label="生日" prop="date"  >
                <el-date-picker
                style="width:100%;"
                disabled
                  v-model="infoContacts.date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择生日">
                </el-date-picker>
              </el-form-item>
              <div style="textAlign: center;margin:20px 0">
                <el-button @click="returnList">关闭</el-button>
              </div>
             </el-form>
            </el-tab-pane>
            <el-tab-pane label="业务账户信息" name="third">
              <el-form
              ref="editMaintenance"
              :model="editMaintenance"
              label-width="120px">
              <div
                v-for="(item, index) in editMaintenance.supAccountData"
                :key="item.key"
                class="clearfix">
                <el-col :span="20">
                  <el-form-item
                    label="账户"
                    :prop="'supAccountData.' + index +'.accName'"
                  >
                    <!-- :rules="rules.supAccountName" -->
                    <el-input disabled maxlength="40" v-model="item.accName" placeholder></el-input>
                  </el-form-item>
                  <el-form-item
                    label="密码"
                    :prop="'supAccountData.'+ index +'.accPwd'"
                  >
                    <el-input disabled maxlength="30" v-model="item.accPwd" placeholder></el-input>
                  </el-form-item>
                  <el-form-item
                    label="APIKey"
                    :prop="'supAccountData.'+ index +'.apiKey'"
                  >
                    <el-input disabled maxlength="60" v-model="item.apiKey" placeholder></el-input>
                  </el-form-item>
                  <el-form-item
                    label="账户状态"
                    :prop="'supAccountData.'+ index +'.accStatus'"
                  >
                    <el-select
                      v-model="item.accStatus"
                      placeholder="请选择账户状态"
                      clearable
                      disabled
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in supAccountStateData"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </div>
              <div style="textAlign: center;margin:20px 0">
                <el-button @click="returnList">关闭</el-button>
              </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="详细信息" name="fourth">
              <el-form
              ref="editMaintenance"
              :model="editMaintenance"
              label-width="120px">
              <el-form-item label="供应商等级" prop="gradeCode">
                <el-select
                  v-model="editMaintenance.gradeCode"
                  placeholder="请选择供应商等级"
                  clearable
                  disabled
                  filterable
                  style="width:100%"
                >
                  <el-option
                    v-for="(item, index) in supLevelList"
                    :key="index"
                    :label="item.gradeName"
                    :value="item.gradeCode"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="供应商资质" prop="qualification">
                <el-select
                  v-model="editMaintenance.qualification"
                  placeholder="请选择供应商资质"
                  clearable
                  disabled
                  filterable
                  style="width:100%"
                >
                  <el-option
                    label="3C认证"
                    value="00001"
                  ></el-option>
                  <el-option
                    label="无认证"
                    value="00002"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属行业" prop="industry">
                <el-select
                  v-model="editMaintenance.industry"
                  placeholder="请选择所属行业"
                  clearable
                  disabled
                  filterable
                  style="width:100%"
                >
                  <el-option
                    v-for="(item, index) in industryData"
                    :key="index"
                    :label="item.industryName"
                    :value="item.industryCode"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="地理位置" prop="province">
                <el-select
                  v-model="editMaintenance.province"
                  placeholder="请选择省"
                  clearable
                  disabled
                  :autocomplete="off"
                  @change="provinceChange"
                  filterable
                  style="width:217px"
                >
                  <el-option
                    v-for="(item, index) in provinceData"
                    :key="index"
                    :label="item.name"
                    :value="item.short_code"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="editMaintenance.city"
                  placeholder="请选择市"
                  @change="cityChange"
                  clearable
                  disabled
                  filterable
                  style="width:217px"
                >
                  <el-option
                    v-for="(item, index) in cityData"
                    :key="index"
                    :label="item.name"
                    disabled
                    :value="item.short_code"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="editMaintenance.area"
                  placeholder="请选择区"
                  clearable
                  disabled
                  filterable
                  style="width:217px"
                >
                  <el-option
                    v-for="(item, index) in areaData"
                    :key="index"
                    :label="item.name"
                    :value="item.short_code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="详细地址" prop="detailInfo">
                <el-input
                  type="textarea"
                  maxlength="60"
                  disabled
                  v-model="editMaintenance.detailInfo"
                  placeholder="请输入详细地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="介绍" prop="intro">
                <el-input
                  type="textarea"
                  disabled
                  maxlength="80"
                  v-model="editMaintenance.intro"
                  placeholder="请输入介绍"
                ></el-input>
              </el-form-item>
              <div style="textAlign: center;margin:20px 0">
                <el-button @click="returnList">关闭</el-button>
              </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="商务信息" name="3">
              <el-form
              ref="editMaintenance"
              :model="editMaintenance"
              label-width="120px">
              <el-form-item label="商务经理" prop="abuName">
                <el-select
                  disabled
                  v-model="editMaintenance.abuName"
                  placeholder="请选择商务经理"
                  clearable
                  style="width:100%"
                >
                  <el-option
                    v-for="(item, index) in abuNameData"
                    :key="index"
                    :label="item.userName"
                    :value="item.userId"
                    @click.native="changeTemplate(item)"
                  ></el-option>
                </el-select>
                <!-- 没有abuid key值报错 -->
              </el-form-item>
              <el-form-item label="商务经理电话" prop="abuMobile">
                <el-input
                  v-model="editMaintenance.abuMobile"
                  placeholder
                  disabled
                  maxlength="11"
                ></el-input>
              </el-form-item>
              <el-form-item label="商务经理邮箱" prop="conBusMail">
                <el-input
                  maxlength="30"
                  disabled
                  v-model="editMaintenance.conBusMail"
                  placeholder="请输入商务经理邮箱"
                ></el-input>
              </el-form-item>
              <div style="textAlign: center;margin:20px 0">
                <el-button @click="returnList">关闭</el-button>
              </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="扩展信息" name="2">
              <el-form
              ref="editMaintenance"
              :model="editMaintenance"
              label-width="120px">
              <div
                v-for="(item, index) in editMaintenance.extFieldList"
                class="clearfix"
                :key="item.key">
                <el-col :span="20">
                  <el-form-item
                    label="属性名"
                    :prop="'extFieldList.'+ index + '.name'"
                  >
                    <el-input disabled maxlength="30" v-model="item.name" placeholder></el-input>
                  </el-form-item>
                  <el-form-item
                    label="属性值"
                    :prop="'extFieldList.'+ index + 'value'"
                  >
                    <el-input disabled maxlength="60" v-model="item.value" placeholder></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <div style="textAlign: center;margin:20px 0">
                <el-button @click="returnList">关闭</el-button>
              </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="合同信息" name="6">
              <el-table
                :data="tableList"
                style="width: 100%"
                >
                <el-table-column prop="contractCode" :show-overflow-tooltip="tooltip" label="合同编号"></el-table-column>
                <el-table-column prop="contractName" :show-overflow-tooltip="tooltip" label="合同名称"></el-table-column>
                <!-- <el-table-column
                  prop="state"
                  label="客户扣款名称"
                ></el-table-column> -->
                <el-table-column prop="contractAmount" :show-overflow-tooltip="tooltip" label="合同金额(元)"></el-table-column>
                <el-table-column prop="transferAmount" :show-overflow-tooltip="tooltip" label="打款金额(元)"></el-table-column>
                <!-- <el-table-column
                  prop="contractValidDate"
                  width="200"
                  :show-overflow-tooltip="tooltip"
                  label="合同有效期"
                ></el-table-column> -->
                <el-table-column prop="contractEffective" :show-overflow-tooltip="tooltip" label="合同有效期"></el-table-column>
                <!-- <el-table-column prop="createTime" :show-overflow-tooltip="tooltip" label="创建时间"></el-table-column> -->
              </el-table>
              <div style="textAlign: center;margin:20px 0">
                <el-button @click="returnList">关闭</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      infoEssential: {
        sysId: '',
        supName: '',
        supId: '',
        supShortName: '',
        paymentType: '',
        state: 1,
        ipaddress: ''
      },
      tooltip: true,
      tableList: [],
      infoContacts: {
        contacts: '',
        conPhone: '',
        conMail: '',
        sex: '',
        post: '',
        date: ''
      },
      editMaintenance: {
        sysId: '',
        supName: '',
        supShortName: '',
        paymentType: '',
        state: 1,
        ipaddress: '',
        contacts: '',
        conPhone: '',
        conMail: '',
        abuName: '',
        abuMobile: '',
        contractEffectiveDate: '',
        /* 账户信息 */
        supAccountData: [
          {
            supAccountId: '',
            supAccountName: '',
            supAccountPwd: '',
            apikey: '',
            state: '',
            supId: ''
          }
        ],
        /* 合同附近 */
        contractFiles: [],
        /* 扩展属性 */
        extFieldList: [
          {
            name: '',
            value: ''
          }
        ]
      },
      /* 付款类型 */
      paymentType: [
        {
          id: 0,
          value: '月结'
        }
      ],
      /* 账户状态 */
      supAccountStateData: [
        {
          id: 1,
          value: '有效'
        },
        {
          id: 0,
          value: '无效'
        }
      ],
      sysData: [],
      supLevelList: [],
      industryData: [],
      provinceData: [],
      cityData: [],
      areaData: [],
      off: 'off',
      abuNameData: [],
      num: '',
      size: '',
      uploadFile: this.$API.fileUpload,
      headers: {
        mtk: localStorage.getItem('usermtk')
      }
    }
  },
  created () {
    /* 查询所属系统列表 */
    let _this = this
    let _self = this
    let params = {
      pageNum: 1,
      pageSize: 1000
    }
    /* 查询地理位置 */
    this.$http({
      method: 'get',
      url: _this.$API.supplier.queryAddrCode
    }).then((response) => {
      let data = response.data.resData
      _this.provinceData = data
      console.log(_this.provinceData)
      _this.queryDetailInfo(_this.$route.query.supId)
    }).catch((error) => {
      console.log(error)
    })
    this.$axios
      .post(this.$API.apiList.querySysList, params)
      .then(function (r) {
        _this.sysData = r.data.resData
      })
      .catch(function (error) { console.log(error) })
    /* 查询供应商等级 */
    this.$http({
      method: 'get',
      url: _this.$API.supplier.queryGradeCode
    }).then((response) => {
      console.log(response.data)
      let data = response.data.resData
      this.supLevelList = data.gradeInfos
    }).catch((error) => {
      console.log(error)
    })
    /* 查询供应商行业 */
    this.$http({
      method: 'get',
      url: _this.$API.supplier.queryIndustryCode
    }).then((response) => {
      console.log(response.data)
      let data = response.data.resData
      _self.industryData = data.industryInfos
    }).catch((error) => {
      console.log(error)
    })
    /* 查询商务经理列表 */
    let type = {abuType: 1}
    this.$axios
      .get(this.$API.supplier.queryBusinessMangerList, {params: type})
      .then(function (r) {
        _this.abuNameData = r.data.resData.userList
      })
      .catch(function (error) {
        console.log(error)
      })
    // this.queryDetailInfo(this.$route.query.supId)
    this.queryEssentialDetail(this.$route.query.supId)
    this.queryContact(this.$route.query.supId)
    this.queryAccount(this.$route.query.supId)
    this.queryBusiness(this.$route.query.supId)
    this.queryExtend(this.$route.query.supId)
    this.queryContract(this.$route.query.supId, this.$route.query.sysId)
    if (this.$route.query.num) {
      this.num = this.$route.query.num
      this.size = this.$route.query.size
    }
  },
  methods: {
    queryDetail (supId) {
      let _self = this
      let params = {
        supId: supId
      }
      console.log(this.abuNameData)
      this.$axios
        .post(this.$API.supplier.querySupInfoBySupId, params)
        .then(function (r) {
          let data = r.data.resData
          _self.editMaintenance = {
            sysId: data.sysId,
            sysName: data.sysName,
            supName: data.supName,
            supShortName: data.supShortName,
            paymentType: data.paymentType,
            state: data.state,
            ipaddress: data.ipaddress,
            contacts: data.supContacts.contacts, // 联系人
            conPhone: data.supContacts.conPhone,
            conMail: data.supContacts.conMail,
            abuName: data.supAbuId, // 商务信息
            abuMobile: data.supAbuMobile,
            /* 合同日期 */
            contractEffectiveDate: data.contractEffectiveDate,
            contractExpirationDate: data.contractExpirationDate,
            /* 账户信息form */
            supAccountData: data.supAccounts ? data.supAccounts : [],
            /* 合同附件form */
            contractFiles: [],
            /* 扩展属性form */
            extFieldList: data.extFieldList
          }
          if (data.contractFiles.length) {
            for (let v of data.contractFiles) {
              let op = {}
              op.name = v.contractFileName
              op.url = v.contractFileUrl
              _self.editMaintenance.contractFiles.push(op)
            }
          }
          if (data.supAbuName) {
            _self.abuMobileBoolean = false
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /* 查询详情信息 */
    queryEditDetail (supId) {
      let params = {
        supId: supId
      }
      let _self = this
      this.$axios
        .post(this.$API.supplier.querySupInfoBySupId, params)
        .then(function (r) {
          let data = r.data.resData
          console.log(r)
          if (data.contractEffectiveDate && data.contractExpirationDate) {
            _self.editMaintenance.contractEffectiveDate = [data.contractEffectiveDate, data.contractExpirationDate]
          } else {
            _self.editMaintenance.contractEffectiveDate = []
          }
          if (data.contractFiles.length) {
            for (let v of data.contractFiles) {
              let op = {}
              op.name = v.contractFileName
              op.url = v.contractFileUrl
              _self.editMaintenance.contractFiles.push(op)
            }
          }
          console.log(_self.editMaintenance.contractFiles)
          if (data.supAbuName) {
            _self.abuMobileBoolean = false
          }
        })
        .catch(function (error) { console.log(error) })
    },
    /* 查询基本信息 */
    queryEssentialDetail (supId) {
      let op = {}
      op.supId = supId
      let _self = this
      this.$http({
        method: 'post',
        url: _self.$API.supplier.querySupInfo,
        data: op
      }).then((response) => {
        console.log(response.data)
        let data = response.data.resData
        _self.infoEssential.sysId = Number(data.sysIds[0])
        _self.infoEssential.supName = data.supName
        _self.infoEssential.supId = data.supId
        _self.infoEssential.supShortName = data.supShortName
        _self.infoEssential.paymentType = data.paymentType
        _self.infoEssential.state = data.state
        _self.infoEssential.ipaddress = data.ipaddress
        // this.tableData = response.data.resData.rows
        // this.total = response.data.resData.total
      }).catch((error) => {
        console.log(error)
      })
    },
    /* 查询联系人信息 */
    queryContact (supId) {
      let op = {}
      op.supId = supId
      let _self = this
      this.$http({
        method: 'post',
        url: _self.$API.supplier.querySupContacts,
        data: op
      }).then((response) => {
        console.log(response.data)
        let data = response.data.resData
        _self.infoContacts.contacts = data.contactName
        _self.infoContacts.conPhone = data.contactTel
        _self.infoContacts.conMail = data.contactMail
        _self.infoContacts.sex = data.sex
        _self.infoContacts.post = data.contactPosition
        _self.infoContacts.date = data.birthday
      }).catch((error) => {
        console.log(error)
      })
    },
    /* 查询账户信息 */
    queryAccount (supId) {
      let op = {}
      op.supId = supId
      let _self = this
      this.$http({
        method: 'post',
        url: _self.$API.supplier.querySupAllAccount,
        data: op
      }).then((response) => {
        console.log(response.data)
        let data = response.data.resData
        _self.editMaintenance.supAccountData = data.accList
      }).catch((error) => {
        console.log(error)
      })
    },
    /* 查询详细信息 */
    queryDetailInfo (supId) {
      let op = {}
      op.supId = supId
      let _self = this
      this.$http({
        method: 'post',
        url: _self.$API.supplier.querySupDetailInfo,
        data: op
      }).then((response) => {
        console.log(response.data)
        let data = response.data.resData
        _self.editMaintenance.gradeCode = data.gradeCode
        _self.editMaintenance.qualification = data.qualificationCode
        _self.editMaintenance.industry = data.industryCode
        _self.editMaintenance.detailInfo = data.addrDetail
        _self.editMaintenance.intro = data.desc
        let where = null
        if (data.addrCode) {
          where = data.addrCode.split('-')
          console.log(where)
          _self.editMaintenance.province = where[0]
          _self.editMaintenance.city = where[1]
          _self.editMaintenance.area = where[2]
          _self.provinceChange(where[0])
          _self.cityChange(where[1])
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    /* 查询商务信息 */
    queryBusiness (supId) {
      let op = {}
      op.supId = supId
      let _self = this
      this.$http({
        method: 'post',
        url: _self.$API.supplier.querySupAbuInfo,
        data: op
      }).then((response) => {
        console.log(response.data)
        let data = response.data.resData
        _self.editMaintenance.abuName = data.abuId
        _self.editMaintenance.abuMobile = data.mobile
        _self.editMaintenance.conBusMail = data.email
      }).catch((error) => {
        console.log(error)
      })
    },
    /* 查询扩展信息 */
    queryExtend (supId) {
      let op = {}
      op.supId = supId
      let _self = this
      this.$http({
        method: 'post',
        url: _self.$API.supplier.querySupExtFieldList,
        data: op
      }).then((response) => {
        console.log(response.data)
        let data = response.data.resData
        _self.editMaintenance.extFieldList = data.extFieldList
      }).catch((error) => {
        console.log(error)
      })
    },
    queryContract (supId, sysId) {
      let op = {}
      op.supId = supId
      op.sysIds = []
      op.contractId = ''
      op.startTime = ''
      op.pageSize = 100
      op.pageNum = 1
      let _self = this
      this.$http({
        method: 'post',
        url: _self.$API.billmanagement.querySupContractListByPage,
        data: op
      }).then((response) => {
        console.log(response.data)
        let data = response.data.resData
        _self.tableList = data.resultList
      }).catch((error) => {
        console.log(error)
      })
    },
    provinceChange (val) {
      console.log(val)
      console.log(this.provinceData)
      if (val && val !== 0) {
        for (let v of this.provinceData) {
          if (v.short_code === val) {
            console.log(v)
            this.cityData = v.city
          }
        }
      } else {
        this.cityData = []
        this.areaData = []
      }
      console.log(this.cityData)
    },
    cityChange (val) {
      console.log(val)
      console.log(this.cityData)
      if (val && val !== 0) {
        for (let v of this.cityData) {
          if (v.short_code === val) {
            this.areaData = v.area
          }
        }
      } else {
        this.areaData = []
      }
    },
    /* 点击文件列表中已上传的文件时的钩子 */
    handlePreview (file) {
      let _width = window.outerWidth
      let _height = window.outerHeight
      window.open(file.url, '_blank', 'width=' + _width + ', height = ' + _height + ', menubar = no,toolbar = no, status = no, scrollbars = yes')
    },
    /* 返回列表 */
    returnList () {
      this.$store.commit('closeTab', this.$route) // 关闭当前路由
      this.$router.push({
        path: '/maintenance',
        query: {
          num: this.num,
          size: this.size
        }
      })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.clearfix {
  @include clearfix;
}
.editMaintenance-title {
  padding-left: 20px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/supper/maintenanceDetails.vue